import * as i0 from "@angular/core";
var JwtService = /** @class */ (function () {
    function JwtService() {
    }
    JwtService.prototype.getToken = function () {
        return window.localStorage['jwtToken'];
    };
    JwtService.prototype.saveToken = function (token) {
        window.localStorage['jwtToken'] = token;
    };
    JwtService.prototype.destroyToken = function () {
        window.localStorage.removeItem('jwtToken');
    };
    JwtService.ngInjectableDef = i0.defineInjectable({ factory: function JwtService_Factory() { return new JwtService(); }, token: JwtService, providedIn: "root" });
    return JwtService;
}());
export { JwtService };
